module.exports = __webpack_public_path__ + "static/media/Board_5@2x.5abb485d.png";